import { components } from 'types/rest-schema';

export type CreateActionModel = components['schemas']['CreateActionModel'];
export type UpdateActionModel = components['schemas']['UpdateActionModel'];
export type DeleteActionModel = components['schemas']['DeleteActionModel'];
export type BulkUpdateActionsDto = components['schemas']['ActionsBulkUpdateDto'];

export type Action = components['schemas']['ActionsDto'] & {
    association: string;
    association_active: boolean;
    completed_date: string;
    completed_date_populated_on: string;
    created_by: string;
    created_date: string;
    description: string;
    comments: string;
    due_date: string | null;
    id: string;
    is_deleted: 'No';
    is_latest: 'Yes';
    observation_id: string;
    owner: string;
    owner_active: boolean;
    panel: string;
    panel_active: boolean;
    record_id: string;
    requested_date: string;
    resolution: string;
    responsible_function: string;
    responsible_function_active: boolean;
    selected: boolean;
    site: string;
    site_id: string;
    status: string;
    updated_by: string;
    updated_date: string;
    observation: string;
    associated_review_log: string | null;
    review_log_id: string | null;
    observation_record_id: string;
    is_scatter_plot: string | null;
    is_poisson_or_negative_binomial: string | null;
    integration_enabled: string;
    integration_enabled_bool: string | null;
    integration_system_id: string | null;
    integration_updated: string;
};

export enum IntegrationState {
    Undefined = '0',
    Enabled = '1',
    PushRequested = '2',
}
